(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-info"]) return;
  try {
    
  // Close other FAQ items when one is opened (accordion behavior)
  (function() {
    const faqAccordion = document.querySelector('.product-info-container > .accordion:nth-child(3) .accordion');
    if (!faqAccordion) return;

    const faqItems = faqAccordion.querySelectorAll('accordion-custom');
    
    faqItems.forEach((item) => {
      const details = item.querySelector('details');
      if (!details) return;

      details.addEventListener('toggle', function() {
        if (details.open) {
          // Close all other FAQ items
          faqItems.forEach((otherItem) => {
            if (otherItem !== item) {
              const otherDetails = otherItem.querySelector('details');
              if (otherDetails && otherDetails.open) {
                otherDetails.open = false;
              }
            }
          });
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
